var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17V3C7 1.896 7.896 1 9 1H31L39 9V37C39 38.104 38.104 39 37 39H9C7.896 39 7 38.104 7 37V31",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 10H30V4",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.08 31H2.92C1.86016 31 1 30.104 1 29V19C1 17.896 1.86016 17 2.92 17H23.08C24.1398 17 25 17.896 25 19V29C25 30.104 24.1398 31 23.08 31Z",
    stroke: "#E37021",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13 26.96C5.39 26.96 5.58667 26.94 5.72 26.9C5.85333 26.86 5.95 26.7833 6.01 26.67C6.07 26.55 6.1 26.3733 6.1 26.14V19.9H7.89V26.22C7.89 26.68 7.83333 27.0533 7.72 27.34C7.60667 27.6267 7.41 27.8433 7.13 27.99C6.85667 28.1367 6.48 28.21 6 28.21H5.13V26.96ZM9.58633 19.9H12.3063C13.0197 19.9 13.553 20.1033 13.9063 20.51C14.2597 20.91 14.4363 21.49 14.4363 22.25C14.4363 23.1167 14.2297 23.72 13.8163 24.06C13.4097 24.3933 12.8363 24.56 12.0963 24.56H11.3763V28H9.58633V19.9ZM11.9763 23.31C12.2897 23.31 12.4963 23.2267 12.5963 23.06C12.703 22.8933 12.7563 22.6133 12.7563 22.22C12.7563 21.86 12.7063 21.5933 12.6063 21.42C12.5063 21.2467 12.293 21.16 11.9663 21.16H11.3763V23.31H11.9763ZM17.9092 28.12C17.1092 28.12 16.5392 27.8767 16.1992 27.39C15.8592 26.9033 15.6892 26.2133 15.6892 25.32V22.6C15.6892 21.6867 15.8726 20.99 16.2392 20.51C16.6126 20.03 17.2392 19.79 18.1192 19.79C18.9659 19.79 19.5726 19.9967 19.9392 20.41C20.3059 20.8233 20.4892 21.4067 20.4892 22.16V22.68H18.7392V22.02C18.7392 21.7 18.7026 21.46 18.6292 21.3C18.5559 21.1333 18.3926 21.05 18.1392 21.05C17.8792 21.05 17.7092 21.14 17.6292 21.32C17.5559 21.5 17.5192 21.75 17.5192 22.07V25.82C17.5192 26.14 17.5659 26.3933 17.6592 26.58C17.7592 26.76 17.9359 26.85 18.1892 26.85C18.6559 26.85 18.8892 26.5 18.8892 25.8V24.85H18.1592V23.8H20.4992V28H19.3192L19.2192 27.33C18.9659 27.8567 18.5292 28.12 17.9092 28.12Z",
    fill: "#E37021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/jpg.c635fa4fcedaa48e29811ad7a2c15e14.svg";
export { ForwardRef as ReactComponent };